module.exports = __webpack_public_path__ + "img/logo-sector-reports.c9ec41f0.png";